<template>
  <div @click="$router.push('/affi/orders/' + order.id)">
    <van-cell :title="'订单号：' + order.trade_no">
      <div class="text-ls-500">{{ order.status_text }}</div>
    </van-cell>
    <div class="flex items-center justify-between px-4 py-2">
      <div class="flex items-center">
        <div class="text-center w-24 h-24 flex items-center">
          <img :src="order.groupon.images[0].image" class="w-full max-h-full" />
        </div>
        <div class="flex flex-col pl-2">
          <div class="flex flex-row items-center">
            <div class="text-sm text-gray-600">{{ order.groupon.title }}</div>
          </div>
          <div class="text-xs text-gray-500 mt-1">买家：{{ order.buyer.nickname }}</div>
          <div class="text-xs text-gray-500 mt-1">数量：{{ order.qty }} <span class="pl-4">总价：￥{{ order.amount }}</span></div>
        </div>
      </div>
      <div>
        <van-icon name="arrow" />
      </div>
    </div>
    <van-cell :title="order.created_at"></van-cell>
  </div>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
      default: () => {
        return {
          id: '',
          trade_no: '',
          qty: 0,
          amount: 0,
          buyer: {
            nickname: ''
          },
          status_text: '',
          status: '',
          groupon: {
            id: '',
            title: '',
            images: [{ image: '', id: null }],
            started_at: '',
            end_at: '',
            ori_price: '',
            price: '',
            status_text: ''
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.van-cell:not(:last-child)::after {
  border: none !important;
}
</style>
